<template>
    <div>
        <div class="col-12 text-right mb-2 p-0">
            <div class="position-relative d-flex justify-content-between align-items-center">
                <input type="text" class="form-control" v-model="filter" v-on:keyup.enter="onFilterChange()" placeholder="Search" />
                <button class="btn custom-button btn-primary" id="add-media-type" text="Add New Media Type" @click="ShowMediaTypeForm = true">
                    Add
                </button>
            </div>
        </div>
         <div class="col-md-12 p-0">
            <template>
                <div class="common-table">
                    <b-table :per-page="perPage" :items="data.rows"
                                :fields="mediaTypeFields"
                                id="all-items"
                                :no-local-sorting="true" @sort-changed="sortChange"
                                show-empty
                                striped
                                hover
                                responsive
                                class="all-items mediaType-table">
                        <template v-slot:cell(UpdatedDate)="data">
                                <div>
                                    {{ data.value | formatDate }}
                                </div>
                            </template>
                        <template v-slot:cell(action)="row">
                            <div class="edit-media-type" >
                                <a class="m-2" v-b-tooltip.hover.v-dark.top.html="'Edit'" @click="EditMediaType(row.item)" ><b-img class="edit-icon" :src="editIcon"/> </a>
                                <a class="m-2" v-b-tooltip.hover.v-dark.top.html="'Delete'" @click="ShowDeleteMediaTypeConfirmation(row.item)" ><b-img class="delete-icon" :src="deleteIcon"/> </a>
                            </div>
                        </template>
                        <template slot="custom-foot" v-if="IsPaginationRequired">
                            <b-tr>
                                <b-td class="custom-pagination" colspan="13">
                                    <b-form-select class="records-per-page" v-model="perPage" :options="RecordsPerPageOption"></b-form-select>
                                    <Pagination style="float: right" :per-page="perPage" aria-controls="open-items" v-model="currentPage" :total-rows="TotalRows" first-number last-number />
                                </b-td>
                            </b-tr>
                        </template>
                    </b-table>
                </div>
            </template>
         </div>
         <b-modal v-model="ShowMediaTypeForm" hide-footer hide-header :no-close-on-backdrop="true">
            <div class="row">
                <div class="col-12 d-flex justify-content-between border-bottom mb-4">
                    <h5 class="modal-title mb-2">{{this.IsEdit ? 'Edit Media Type' : 'Add Media Type'}}</h5>
                    <button class="close" @click="HidePopUpForm()"></button>
                </div>
                <div class="col-10 mx-auto">
                    <div class="mb-2">
                        <label>Instance</label>
                        <OmniSelect class="" placeholder="Select Instance" name="Instance" :showLabel="false" label="value" v-model="MediaType.Entity" :options="EntityList"></OmniSelect>
                    </div>
                    <div class="mb-2">
                        <label>Master Media</label>
                        <OmniSelect class="" placeholder="Select Master Media" name="MasterMedia" :showLabel="false" label="value" v-model="MediaType.MasterMedia" :options="MasterMediaList"></OmniSelect>
                    </div>
                    <div class="mb-2">
                        <label>Media Type Name</label>
                        <b-form-input v-model="MediaType.MediaTypeName" :maxlength="50" placeholder="Enter Media Type Name" id="MediaTypeName"></b-form-input>
                    </div>
                    <div class="mb-2">
                        <label>Spectra Code</label>
                        <b-form-input v-model="MediaType.SpectraCode" :maxlength="2" placeholder="Enter Spectra Code" id="SpectraCode"></b-form-input>
                    </div>
                    <div class="mb-2">
                        <label>Prisma Code</label>
                        <b-form-input v-model="MediaType.PrismaCode" :maxlength="2" placeholder="Enter Prisma Code" id="PrismaCode"></b-form-input>
                    </div>
                    <div class="mb-2">
                        <label>Select the Form Type this Media type applies to</label>
                        <div class="fieldborder" style="">
                            <OmniSelect placeholder="Select Form Types" name="FormTypes" :showLabel="false" v-model="ApplicableToFormTypes" :options="FormTypes" />
                        </div>
                    </div>
                    <div class="mb-2">
                        <label>Display Order
                            <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            v-b-tooltip.hover.v-dark.right.html="'Enter a numeric value to set the display order. Media Types with lower values will appear first in dropdown lists.'
                                ">
                            <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path
                                    d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                    id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                        </label>
                        <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##']" class="form-control" id="DisplayOrder" v-model="MediaType.DisplayOrder" placeholder="Enter Display Order"></the-mask>
                    </div>
                    <div class="text-right my-4">
                        <button class="btn btn-link text-uppercase" @click="HidePopUpForm()">Cancel</button>
                        <button v-if="this.IsEdit" class="text-uppercase btn btn-primary" :disabled="this.$v.$invalid" @click="UpdateMediaTypeForm()">Update</button>
                        <button v-else class="text-uppercase btn btn-primary" :disabled="this.$v.$invalid" @click="SubmitMediaTypeForm()">Submit</button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal modal-class="cancel-request" v-model="ShowDeletionConfirmation" dialog-class="cancel-request" :no-close-on-backdrop="true" size="sm">
            <template v-slot:modal-header="{ close }">
                <h5 class="modal-title">Delete Media Type</h5>
                <button class="close" @click="Cancel()"></button>
            </template>
            <p class="cancel-info-text">
                Are you sure you want to delete the Media Type: {{selectedMediaType?.MediaTypeName}}?
            </p>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <b-button variant="primary"   class="float-right" @click="DeleteMediaType()">Yes</b-button>
                    <b-button variant="secondary" class="float-right" @click="Cancel()">No</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import tabtable from "../../mixins/tabtable";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
import store from "@/store";
import { TheMask } from 'vue-the-mask'
import {UpdateRecordsPerPageOption} from "../../utilities/paginationUtils";
const moment = require("moment");
export default {
    name: "MediaType",
    mixins: [tabtable],
    components: {
        TheMask
    },
    validations: {
        MediaType: {
            Entity: { required },
            MasterMedia: { required },
            MediaTypeName: { required },
            SpectraCode: {
                required: requiredIf(function () {
                    return this.MediaType.PrismaCode == null || this.MediaType.PrismaCode.trim() == "";
                }),
            },
            PrismaCode: {
                required: requiredIf(function () {
                    return this.MediaType.SpectraCode == null || this.MediaType.SpectraCode.trim() == "";
                }),
            },
            ApplicableToFormTypes: { required },
            DisplayOrder: { required },
        }
    },
    data() {
        return {
            sortBy: "UpdatedDate",
            filter: null,
            TotalRows: 0,
            perPage: 10,
            currentPage: 1,
            data: {
                config: {
                    card_mode: false,
                    show_refresh_button: false,
                    show_reset_button: false,
                    pagination_info: true,
                    global_search: {
                        visibility: false,
                    },
                },
                loading: false,
                classes: {
                    tableWrapper: "outer-table-div-class wrapper-class-two grid-table",
                    table: {
                        "table-sm": true,
                    },
                },
                rows: [],
            },
            IsEdit: false,
            selectedMediaType: null,
            mediaTypeFields: [
                { key: 'Entity', label: 'Instance' ,sortable: true },
                { key: 'MasterMedia', label: 'Master Media' ,sortable: true },
                { key: 'MediaTypeName', label: 'Media Type Name' ,sortable: true },
                { key: 'SpectraCode', label: 'Spectra Code' ,sortable: true },
                { key: 'PrismaCode', label: 'Prisma Code' ,sortable: true },
                { key: 'ApplicableToFormTypes', label: 'Applicable To Form Type' ,sortable: true },
                { key: 'DisplayOrder', label: 'Display Order' ,sortable: true },
                { key: 'UpdatedBy', label: 'Updated By' ,sortable: true },
                { key: 'UpdatedDate', label: 'Updated Date' ,sortable: true },
                { key: 'action', label: 'Action' },
            ],
            FormTypes: [
                { value: 'Client/Product', label: 'Client/Product' },
                { value: 'Media Vendor', label: 'Media Vendor' },
            ],
            editIcon: require("@/assets/Icons/edit.svg"),
            deleteIcon: require("@/assets/Icons/delete.svg"),
            ShowMediaTypeForm: false,
            ShowDeletionConfirmation: false,
            EntityList: [
                { value: 'Omnicom Media', label: 'Omnicom Media' },
                { value: 'Zimmerman', label: 'Zimmerman' },
            ],
            MasterMediaList: [
                { value: 'Spot', label: 'Spot' },
                { value: 'Net', label: 'Net' },
                { value: 'Print', label: 'Print' }
            ],
            ApplicableToFormTypes: [],
        }
    },
    props: {
        activeTab: {
            type: String,
            default: null
        }
    },
    mounted() {
        if (!this.CanAccessList) {
            this.$router.push({
                name: "unauthorized",
                params: {
                    message: "UnAuthorized"
                },
            });
        }
        this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowWidth);
        });
    },
    watch: {
        activeTab: function (value) {
            if(value === 'Media Types'){
                this.GetAllMediaTypes();
            }
        },
        ApplicableToFormTypes: function (value) {
            if(value != null && value.length > 0) {
                this.MediaType.ApplicableToFormTypes = value.join(',');
            }
            else {
                this.MediaType.ApplicableToFormTypes = null;
            }
        },
        filter(e) {
            if ((e != null && e.length > 2) || e == null || e.length == 0) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.currentPage = 1;
                    this.GetAllMediaTypes();
                }, 500);
            }
        },
        currentPage: function (value) {
            if (value != null && parseInt(value) > 0) {
                this.GetAllMediaTypes();
            }
        },
        perPage: function () {
            this.currentPage = 1;
            this.GetAllMediaTypes();
        }
    },
    computed: {
        ...mapGetters('mediaType', {
            MediaType: 'MediaType',
        }),
        CanAccessList() {
            return this.$store.getters.canAccessMediaTypeManagement;
        },
        IsPaginationRequired() {
            return this.TotalRows != null && parseInt(this.TotalRows) > parseInt(this.perPage);
        },
    },
    filters: {
        formatDate(date) {
            return moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : "-";
        },
    },
    methods: {
        GetGridOptions() {
            return {
                PageSize: parseInt(this.perPage),
                CurrentPageNumber: parseInt(this.currentPage),
                FilterValue: this.filter,
                SortBy: this.sortBy,
                SortDesc: this.sortDesc,
            };
        },
        sortChange(e) {
            this.sortBy = e.sortBy;
            this.sortDesc = e.sortDesc;
            this.GetAllMediaTypes();
        },
        HidePopUpForm() {
            this.ShowMediaTypeForm = false;
            this.IsEdit = false;
            this.MediaType.Id = 0;
            this.MediaType.Entity = null;
            this.MediaType.MasterMedia = null;
            this.MediaType.MediaTypeName = null;
            this.MediaType.SpectraCode = null;
            this.MediaType.PrismaCode = null;
            this.ApplicableToFormTypes = [];
            this.MediaType.DisplayOrder = null;
        },
        EditMediaType(item) {
            this.IsEdit = true;
            this.MediaType.Id = parseInt(item.ID);
            this.MediaType.Entity = item.Entity;
            this.MediaType.MasterMedia = item.MasterMedia;
            this.MediaType.MediaTypeName = item.MediaTypeName;
            this.MediaType.SpectraCode = item.SpectraCode;
            this.MediaType.PrismaCode = item.PrismaCode;
            this.MediaType.DisplayOrder = item.DisplayOrder;
            this.ApplicableToFormTypes = item.ApplicableToFormTypes ? item.ApplicableToFormTypes.split(',') : [];
            this.ShowMediaTypeForm = true;
        },
        ShowDeleteMediaTypeConfirmation(item) {
            this.selectedMediaType = item;
            this.ShowDeletionConfirmation = true;
        },
        DeleteMediaType() {
            this.$store
            .dispatch('mediaType/DeleteMediaType', parseInt(this.selectedMediaType.ID))
            .then(() => {
                this.GetAllMediaTypes();
                store.dispatch(
                        "progress/setSuccessMessage",
                        "Media Type has been deleted successfully!"
                    );
            })
            .catch((ex) => {
                if (ex.response && [400, 403].includes(ex.response.status)) {
                    store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
                else {
                window.console.log(JSON.stringify(ex));
                    store.dispatch(
                        "progress/setErrorMessage",
                        "Error while deleting Media Type"
                    );
                }
            });
            this.Cancel();
        },
        Cancel() {
            this.ShowDeletionConfirmation = false;
            this.selectedMediaType = null;
        },
        SubmitMediaTypeForm() {
            this.$store
            .dispatch('mediaType/AddMediaType', this.MediaType)
            .then(() => {
                this.GetAllMediaTypes();
                store.dispatch(
                        "progress/setSuccessMessage",
                        "Media Type has been added successfully!"
                    );
            })
            .catch((ex) => {
                if (ex.response && [400, 403].includes(ex.response.status)) {
                    store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
                else {
                window.console.log(JSON.stringify(ex));
                    store.dispatch(
                        "progress/setErrorMessage",
                        "Error while adding Media Type"
                    );
                }
            });
            this.HidePopUpForm();
        },
        UpdateMediaTypeForm() {
            this.$store
            .dispatch('mediaType/UpdateMediaType', { id: this.MediaType.Id, data: this.MediaType })
            .then(() => {
                this.GetAllMediaTypes();
                store.dispatch(
                        "progress/setSuccessMessage",
                        "Media Type has been updated successfully!"
                    );
            })
            .catch((ex) => {
                if (ex.response && [400, 403].includes(ex.response.status)) {
                    store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
                else {
                window.console.log(JSON.stringify(ex));
                    store.dispatch(
                        "progress/setErrorMessage",
                        "Error while updating Media Type"
                    );
                }
            });
            this.HidePopUpForm();
        },
        GetAllMediaTypes() {
            this.TotalRows = 0;
            this.data.rows = [];
            this.$store
                .dispatch("mediaType/GetAllMediaTypes", this.GetGridOptions())
                .then((res) => {
                    if (res.data) {
                        this.data.rows = res.data.Result;
                        this.TotalRows = res.data.Total;
                        this.RecordsPerPageOption = UpdateRecordsPerPageOption(this.TotalRows);
                    }
                })
                .catch((ex) => {
                    if (ex.response) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `${ex.response.data}`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error fetching media types.${ex}`
                        );
                    }
                });
        },
    },
}
</script>
<style>
    .edit-media-type {
        display: flex;
        width: 20px;
        height: 7.5px;
        align-items: center;
    }
    .edit-media-type a {
        cursor: pointer;
    }
    .common-table .mediaType-table .table thead th {
        padding-left:15px !important;
    }
    .common-table .mediaType-table table tbody tr td {
        padding: 7.5px 15px !important;
    }
    .cancel-info-text {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.57;
        letter-spacing: normal;
        color: #47505a;
        padding-left: 20px;
    }
</style>